import { CitizenFilterKeyString } from 'CitizenProfile/types'
import { FREQUENCIE_ACTIVITIES_TYPES_INITIAL_FILTER } from 'components/filters/FrequencieActivitiesTypesFilterTemplate/constants'
import { METADATA_INITIAL_FILTER } from 'components/filters/MetadatasFilterTemplate/constants'
import { CITIZEN_FIELDS_INITIAL_VALUES } from '.'

export const CITIZEN_INITIAL_FILTER: CitizenFilterKeyString = {
  ...CITIZEN_FIELDS_INITIAL_VALUES,
  ...METADATA_INITIAL_FILTER,
  ...FREQUENCIE_ACTIVITIES_TYPES_INITIAL_FILTER,
  activity_type_name: '',
  place_name: '',
  search_fields: ['name', 'cpf_number'],
}
